import React from 'react';
import { useIntl } from 'react-intl';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { reviewMessages as messages } from './reviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from './Review.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReviewStepBarProps {
  index: number;
  total: number;
  isBusy: boolean;
  isBlocked: boolean;
  disabled: boolean;
  onSkip: () => void;
  onEdit: () => void;
  onApprove: () => void;
}

/** The bar under the pitch (design outreach-v2 h1): Skip, Edit, "2 of 5", "Approve and next". */
const ReviewStepBarComponent: React.FC<ReviewStepBarProps> = ({
  index,
  total,
  isBusy,
  isBlocked,
  disabled,
  onSkip,
  onEdit,
  onApprove,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.stepBar} data-testid="review-step-bar">
      <div className={styles.stepLeft}>
        <SMLButton size="sm" color="link" omitCap onClick={onSkip} disabled={disabled || isBusy}>
          {intl.formatMessage(messages.skip)}
        </SMLButton>
        <SMLButton size="sm" outline omitCap leftIcon={faPen} onClick={onEdit} disabled={disabled}>
          {intl.formatMessage(messages.edit)}
        </SMLButton>
      </div>
      <div className={styles.stepMiddle}>
        {intl.formatMessage(messages.position, { index, total })}
        <br />
        <small>{intl.formatMessage(messages.keys)}</small>
      </div>
      <SMLButton
        color="primary"
        omitCap
        leftIcon={faCheck}
        onClick={onApprove}
        isLoading={isBusy}
        disabled={disabled || isBlocked || isBusy}
        testID="review-approve-next"
      >
        {intl.formatMessage(messages.approveNext)}
      </SMLButton>
    </div>
  );
};

export const ReviewStepBar = TypedMemo(ReviewStepBarComponent);
